<div class="container-fluid">
  <div class="row mt-3">
    <div class="col">
      <h2>
        {{
          currentRouteInfo
            ? 'Contracts - ' + currentRouteInfo.title
            : 'Contracts'
        }}
      </h2>
      <div class="row">
        <div class="col">
          <app-display-card class="m-3" [panelHeight]="'fit'">
            <div class="inner-panel rounded">
              <router-outlet></router-outlet>
            </div>
          </app-display-card>
        </div>
      </div>
      <div class="row my-3 justify-content-end">
        <div class="col col-xl-2">
          <button
            class="btn"
            [ngClass]="{
              'btn-danger':
                currentRouteInfo &&
                currentRouteInfo.currentRoute === 'addContract',
              'btn-primary':
                currentRouteInfo &&
                currentRouteInfo.currentRoute !== 'addContract'
            }"
            (click)="cancel()"
          >
            {{
              currentRouteInfo &&
              currentRouteInfo.currentRoute === 'addContract'
                ? 'Cancel'
                : 'Back'
            }}
          </button>
        </div>
        @if (!viewingContract) {
          <div class="col col-xl-3">
            <button class="btn btn-primary" (click)="saveAndClose()">
              Save And Close
            </button>
          </div>
        }
        @if (!viewingContract) {
          <div class="col col-xl-3">
            <button class="btn btn-primary" (click)="saveAndContinue()">
              {{
                currentRouteInfo && currentRouteInfo.currentRoute === 'review'
                  ? 'FINISH'
                  : 'Save And Continue'
              }}
            </button>
          </div>
        }
      </div>
    </div>
  </div>
</div>
